import { useState } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <nav className="fixed top-3 inset-x-3 z-50">
      <div className="mx-auto max-w-7xl">
        <div className="rounded-2xl bg-background-50/80 backdrop-blur-xl border border-background-200/60 px-4 md:px-6 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2 flex-shrink-0">
            <Link to="/" className="flex items-center gap-2 flex-shrink-0">
              <div className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-file-excel-2-line text-background-50 text-lg w-5 h-5 flex items-center justify-center"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-950 whitespace-nowrap">CSSSpreadsheet</span>
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-1 flex-1 justify-center mx-4">
            <div className="relative w-full max-w-md">
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className="w-full flex items-center justify-between gap-2 px-5 py-2.5 bg-background-100 rounded-full text-sm text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap"
              >
                <span>Shop Categories</span>
                <i className={`ri-arrow-down-s-line transition-transform duration-200 text-base ${isDropdownOpen ? "rotate-180" : ""} w-5 h-5 flex items-center justify-center`}></i>
              </button>

              {isDropdownOpen && (
                <>
                  <div className="fixed inset-0 z-40" onClick={() => setIsDropdownOpen(false)}></div>
                  <div className="absolute top-full mt-2 left-0 right-0 bg-background-50 rounded-2xl border border-background-200/60 shadow-lg z-50 p-4">
                    <div className="grid grid-cols-2 gap-2">
                      {categories.map((cat) => (
                        <a
                          key={cat.slug}
                          href={cat.url}
                          target="_blank"
                          rel="noopener nofollow"
                          className="flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-accent-100/60 transition-colors group cursor-pointer"
                          onClick={() => setIsDropdownOpen(false)}
                        >
                          <div className="w-8 h-8 rounded-lg overflow-hidden flex-shrink-0 bg-background-200">
                            <img
                              src={cat.thumbUrl}
                              alt={`${cat.name} - CSSBuy Spreadsheet Shopping Category`}
                              title={`${cat.name} - CSSBuy Spreadsheet`}
                              className="w-full h-full object-cover object-top"
                              loading="lazy"
                            />
                          </div>
                          <span className="text-sm text-foreground-800 group-hover:text-foreground-950 whitespace-nowrap">{cat.name}</span>
                        </a>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          <div className="hidden md:flex items-center gap-3 flex-shrink-0">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors flex items-center gap-2 cursor-pointer whitespace-nowrap"
            >
              cssbuy sheet
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2.5 bg-primary-700 text-background-50 rounded-full text-sm font-medium hover:bg-primary-800 transition-colors flex items-center gap-2 cursor-pointer whitespace-nowrap"
            >
              buy it now
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>

          <button
            className="md:hidden flex items-center justify-center w-10 h-10 rounded-full hover:bg-background-200 transition-colors cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`${isMobileMenuOpen ? "ri-close-line" : "ri-menu-line"} text-foreground-800 text-xl w-6 h-6 flex items-center justify-center`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden mt-2 bg-background-50 rounded-2xl border border-background-200/60 p-4">
            <div className="grid grid-cols-2 gap-2 mb-4 max-h-64 overflow-y-auto">
              {categories.map((cat) => (
                <a
                  key={cat.slug}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-2 px-3 py-2.5 rounded-xl hover:bg-accent-100/60 transition-colors cursor-pointer"
                >
                  <div className="w-7 h-7 rounded-lg overflow-hidden flex-shrink-0 bg-background-200">
                    <img src={cat.thumbUrl} alt={`${cat.name} - CSSBuy Spreadsheet Shopping Category`} title={`${cat.name} - CSSBuy Spreadsheet`} className="w-full h-full object-cover object-top" loading="lazy" />
                  </div>
                  <span className="text-xs text-foreground-800 whitespace-nowrap">{cat.name}</span>
                </a>
              ))}
            </div>
            <div className="flex flex-col gap-2">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-5 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium text-center hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                cssbuy sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-5 py-3 bg-primary-700 text-background-50 rounded-full text-sm font-medium text-center hover:bg-primary-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                buy it now
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}